// src/Common/InputField.jsx
import React, { useState } from "react";

const InputField = ({
  label,
  type = "text",
  name,
  value,
  onChange,
  onBlur,
  placeholder,
  required = false,
  icon = null,
  disabled = false,
  className = "",
  error = "",
  maxLength,
  readOnly = false,
}) => {
  const [showPassword, setShowPassword] = useState(false);
  const isPassword = type === "password";

  return (
    <div className={className}>
      {label && (
        <label className="block text-[11px] font-bold text-slate-500 uppercase tracking-widest mb-2">
          {label}
          {required && <span className="text-red-500 ml-1">*</span>}
        </label>
      )}
      <div className="relative">
        {icon && (
          <span className="absolute left-4 top-1/2 -translate-y-1/2 material-symbols-outlined text-slate-400 text-lg">
            {icon}
          </span>
        )}
        <input
          type={isPassword && showPassword ? "text" : type}
          name={name}
          value={value}
          onChange={(e) => {
            const raw = e.target.value;
            const val = isPassword
              ? raw.replace(/\s/g, "")
              : raw.replace(/^\s+/, "");
            onChange(val, e);
          }}
          onBlur={onBlur}
          placeholder={placeholder}
          disabled={disabled}
          readOnly={readOnly}
          maxLength={maxLength}
          className={`w-full ${icon ? "pl-12" : "px-4"} ${isPassword ? "pr-12" : "pr-4"} py-3 bg-slate-50 rounded-lg text-sm text-slate-700 font-medium focus:ring-2 focus:ring-primary/20 focus:border-primary outline-none transition-all disabled:opacity-50 disabled:cursor-not-allowed ${
            readOnly ? "cursor-not-allowed" : ""
          } ${error ? "border-2 border-red-500" : "border border-slate-200"}`}
        />
        {isPassword && (
          <button
            type="button"
            onClick={() => setShowPassword(!showPassword)}
            className="absolute right-4 top-1/2 -translate-y-1/2 text-slate-400 hover:text-primary transition-colors"
          >
            <span className="material-symbols-outlined text-lg">
              {showPassword ? "visibility_off" : "visibility"}
            </span>
          </button>
        )}
      </div>
      {error && <p className="text-xs text-red-500 mt-1">{error}</p>}
    </div>
  );
};

export default React.memo(InputField);
